import { Route } from '@angular/router';

export const LIST_ROUTES: Route[] = [
    {
        path: '',
        loadComponent: () => import('./list.component').then((comp) => comp.ListComponent)
    }
];
